class DocumentObj {
    constructor(data, folder_stack, path_document_id) {
        this.id = data.id;
        this.minimum_qualification = data.minimum_qualification;
        this.has_test = data.has_test;
        this.own_game = data.own_game;
        this.own_test = data.own_test;
        this.own_poll = data.own_poll;
        this.name = data.name;
        this.type = data.type_i18n;
        this.icon_type = data.icon_type;
        this.folder_stack = folder_stack;
        this.is_path_content = path_document_id !== null && path_document_id !== undefined;
        this.path_document_id = path_document_id;
    }
}